// This ensures that the icon CSS is loaded immediately before attempting to render icons
import "@fortawesome/fontawesome-svg-core/styles.css";
import { config } from "@fortawesome/fontawesome-svg-core";

// Supports weights 100-900
import '@fontsource-variable/noto-sans-lao/wght.css';

// Supports weights 300-700
import '@fontsource-variable/quicksand/wght.css';

import '@fontsource/bebas-neue';

import "./src/sass/style.scss";

// Prevent fontawesome from dynamically adding its css since we did it manually above
config.autoAddCss = false;

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  window.scrollTo(0, 0);

  return false;
};